module.exports = __webpack_public_path__ + "img/zh_CN.5a080ea.webp";